import { render, staticRenderFns } from "./CollectionCreateForm.vue?vue&type=template&id=fa0a9c38&"
import script from "./CollectionCreateForm.vue?vue&type=script&lang=js&"
export * from "./CollectionCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports